import { Component, computed, input, output } from "@angular/core";
import { PageInfo } from "../../../../../gql/possible-types-ingestor.ts/graphql";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "pagination-default",
  templateUrl: "default.html",
  styleUrls: ["../../pagination.scss"],
  imports: [AngularSvgIconModule],
})
export class PaginationDefault {
  pageInfo = input<PageInfo>({
    filterFields: [],
    hasNextPage: false,
    hasPreviousPage: false,
    sortFields: [],
    endCursor: 0,
    startCursor: 0,
    totalItems: 0,
  });
  prevPage = output();
  nextPage = output();

  hasNextPage = computed(() => this.pageInfo().hasNextPage ?? false);
  hasPreviousPage = computed(() => this.pageInfo().hasPreviousPage ?? false);
}
